






















































import Vue, { PropType } from 'vue';

import { VaultItem, VaultMinMeta, VaultPostItem } from 'vaultifier';
import RawData from './RawData.vue';

import FormView from './FormView.vue';

import { ActionType } from '@/store/action-type';
import { IStore, MutationType } from '../store';

interface Data {
  isSaving: boolean;
  activeTabIndex: number;
}

export default Vue.extend({
  props: {
    item: Object as PropType<VaultItem | undefined>,
    showRawView: {
      default: true,
      type: Boolean as PropType<boolean>,
    },
  },
  data: (): Data => ({
    isSaving: false,
    activeTabIndex: 0,
  }),
  components: {
    RawData,
    FormView,
  },
  computed: {
    schemaDri(): string | undefined {
      return this.item?.dri;
    },
    hasSchema(): boolean {
      return !!this.schemaDri;
    },
    language() {
      return (this.$store.state as IStore).vaultItem.language;
    },
  },
  methods: {
    async saveVaultItem(item: VaultPostItem, onComplete?: () => void) {
      this.isSaving = true;

      try {
        await this.$store.dispatch(ActionType.UPDATE_VAULT_ITEM, item);
      } catch (e: any) {
        console.error(e);
        this.$bvToast.toast(e.message || "Unknown error", {
          title: "Error while saving item",
          variant: "danger",
          solid: true,
        });
      }

      this.isSaving = false;

      if (onComplete)
        // indicate saving is complete
        onComplete();
    },
    cancel() {
      this.$emit('cancel');
    },
  },
})
